import type { EventResults } from './types';

/**
 * Returns event end time in ms from the results payload, or null if not available.
 * Uses end_timestamp (seconds) if present, else event_timestamp + duration (seconds).
 */
export function getEventEndMsFromResults(data: EventResults | null | undefined): number | null {
  if (!data || typeof data !== 'object') return null;
  const endSec = data.end_timestamp;
  if (endSec != null && (typeof endSec === 'number' || typeof endSec === 'string')) {
    const n = Number(endSec);
    if (Number.isFinite(n)) return n * 1000;
  }
  const ts = data.event_timestamp;
  const dur = data.duration;
  if (
    ts != null &&
    (typeof ts === 'number' || typeof ts === 'string') &&
    dur != null &&
    (typeof dur === 'number' || typeof dur === 'string')
  ) {
    const t = Number(ts);
    const d = Number(dur);
    if (Number.isFinite(t) && Number.isFinite(d)) return (t + d) * 1000;
  }
  return null;
}
